//wordpress dependencies
const { __ } = wp.i18n;
const { useState, useEffect, Component, createRef } = wp.element;
const {
	BlockControls,
	BlockAlignmentToolbar

} = wp.blockEditor;
const { Spinner } = wp.components;
import axios from "axios";
import Qs from "qs";
import "./editor.scss";
import "./style.scss";
import Inspector from "./inspector";
import RenderView from "./renderView";
import classnames from "classnames";
import { CssGenerator } from "../../util/css/CssGenerator";

function Edit(props) {
	const { isSelected, attributes, setAttributes, clientId, className } = props;

	const { align, blockId} = attributes;
	const _client = clientId.substr(0, 6);
	useEffect(() => {
		if (!blockId) {
			setAttributes({ blockId: _client });
		} else if (blockId && blockId !== _client) {
			setAttributes({ blockId: _client });
		}
	}, []);

	const [catListBox, setCatListBox] = useState([]);
	const [dataSuccess, setDataSuccess] = useState(true);
	const [catSideQuery, setCatSideQuery] = useState(false);

	const catSideQueryChange = () => {
		setCatSideQuery(!catSideQuery);
	}

	useEffect(() => {
		let data = {
			action: 'rtcl_gb_listing_cat_box',
			rtcl_nonce: rtcl_block_script.rtcl_nonce,
			attributes: attributes
		}

		axios.post(rtcl_block_script.ajaxurl, Qs.stringify(data))
			.then((response) => {
				if (response.data.success) {
					setCatListBox([...response.data.data]);
					setDataSuccess(response.data.success)
				} else {
					setCatListBox([]);
					setDataSuccess(response.data.success)
				}
			})
			.catch((error) => console.log(error));

	}, [catSideQuery]);

	// Check if the post
	const hasPosts = Array.isArray(catListBox) && catListBox.length;
	if (!hasPosts) {
		return [
			isSelected && (
				<Inspector
					attributes={attributes}
					setAttributes={setAttributes}
					catSideQueryChange={catSideQueryChange}
				/>
			),
			dataSuccess ? (<div className="rtcl-gb-spinner"><Spinner /></div>) : (
				__('No posts found.', 'classified-listing')
			)
		];
	}

	if (blockId) {
		CssGenerator(attributes, 'listing-cat-box-slider', blockId);
	}

	const MainWrapperClass = classnames([
		'rtcl-block-' + blockId,
		className,
		'rtcl-block-editor'
	]);

	return [
		<BlockControls key="controls">
			<BlockAlignmentToolbar
				value={align}
				onChange={(newaAlign) => setAttributes({ align: newaAlign })}
				controls={['center', 'wide', 'full']}
			/>
		</BlockControls>,
		isSelected && (
			<Inspector
				attributes={attributes}
				setAttributes={setAttributes}
				catSideQueryChange={catSideQueryChange}
			/>
		),
		<div className={MainWrapperClass}>
			<RenderView {...attributes} data={catListBox} />
		</div>
	]
}

export default Edit;